export interface AccentTheme {
  id: string;
  labelKey: string;       // i18n key
  primary: string;        // main accent color
  hover: string;          // darker for hover states
  glow: string;           // 12% opacity for focus rings, highlights
  soft: string;           // 6% opacity for light backgrounds
  gradientDark: string;   // darker end for gradients
  gradientLight: string;  // lighter end for gradients
}

export const ACCENT_THEMES: Record<string, AccentTheme> = {
  blue: {
    id: "blue",
    labelKey: "settings:accent.blue",
    primary: "#3498DB",
    hover: "#2980B9",
    glow: "rgba(52, 152, 219, 0.12)",
    soft: "rgba(52, 152, 219, 0.06)",
    gradientDark: "#2E86C1",
    gradientLight: "#5DADE2",
  },
  teal: {
    id: "teal",
    labelKey: "settings:accent.teal",
    primary: "#0D9488",
    hover: "#0B7E74",
    glow: "rgba(13, 148, 136, 0.12)",
    soft: "rgba(13, 148, 136, 0.06)",
    gradientDark: "#0A7569",
    gradientLight: "#2DD4BF",
  },
  indigo: {
    id: "indigo",
    labelKey: "settings:accent.indigo",
    primary: "#4F46E5",
    hover: "#4338CA",
    glow: "rgba(79, 70, 229, 0.12)",
    soft: "rgba(79, 70, 229, 0.06)",
    gradientDark: "#3730A3",
    gradientLight: "#818CF8",
  },
  emerald: {
    id: "emerald",
    labelKey: "settings:accent.emerald",
    primary: "#059669",
    hover: "#047857",
    glow: "rgba(5, 150, 105, 0.12)",
    soft: "rgba(5, 150, 105, 0.06)",
    gradientDark: "#065F46",
    gradientLight: "#34D399",
  },
  amber: {
    id: "amber",
    labelKey: "settings:accent.amber",
    primary: "#D97706",
    hover: "#B45E05",
    glow: "rgba(217, 119, 6, 0.12)",
    soft: "rgba(217, 119, 6, 0.06)",
    gradientDark: "#92400E",
    gradientLight: "#FBBF24",
  },
  slate: {
    id: "slate",
    labelKey: "settings:accent.slate",
    primary: "#475569",
    hover: "#334155",
    glow: "rgba(71, 85, 105, 0.12)",
    soft: "rgba(71, 85, 105, 0.06)",
    gradientDark: "#1E293B",
    gradientLight: "#94A3B8",
  },
};

export const DEFAULT_ACCENT_ID = "blue";
export const ACCENT_THEME_STORAGE_KEY = "accentTheme";
